import React from 'react';

export const SlicerContext = React.createContext();
